import { makeObservable, observable, action } from 'mobx';

import UserService from 'src/services/user';

class UserStore {
  @observable id = null;
  @observable name = null;
  @observable group = null;

  constructor() {
    makeObservable(this);
  }

  @action async checkUserStatus() {
    if (this.id) {
      return {
        id: this.id,
        name: this.name,
        group: this.group
      };
    }

    const userInfo = await UserService.getProfile();

    this.id = userInfo.id;
    this.name = userInfo.name;
    this.group = userInfo.group;

    return {
      id: this.id,
      name: this.name,
      group: this.group
    };
  }

  @action logout() {
    this.id = null;
    this.name = null;
    this.group = null;
  }
}

const userStore = new UserStore();

export default userStore;
